import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=002c6a04&"
import script from "./editPage.vue?vue&type=script&lang=ts&"
export * from "./editPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports